import SlideMenuActionResolver from '@/services/ActionResolvers/SlideMenuActionResolver';
import {IEaasiResource} from '@/types/Resource';
import {IAction} from 'eaasi-nav';
import {translatedIcon} from '@/utils/constants';

export default class BookmarkResourceActionResolver extends  SlideMenuActionResolver {
	selectedResources: IEaasiResource[];
	userRoleId: number;

	constructor(selectedResources: IEaasiResource[], roleId: number) {
		super(selectedResources, roleId);
	}

	/**
	 * Resolves custom behavior of an action
	 */
	get action() : IAction {
		return {
			shortName: 'bookmark',
			label: 'Bookmark This Resource',
			description: 'Add resource to my bookmarks in my resources',
			icon: translatedIcon('bookmark'),
			isEnabled: true
		};
	}
}
